import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const movementRoute = {
    FIND_MOVEMENT_BY_COMPANY: "dashboard/core/slot-detail/find-movements-purge",
    SAVE: "dashboard/core/slot-detail/save-movements-purge",
};

export default {
    findMovementByCompany(startDate,endDate,initials,isIncomeItem, consecutive) {
        return new Promise(resolve => {
            let newData = [];
            http.get(movementRoute.FIND_MOVEMENT_BY_COMPANY,{params: {startDate,endDate,initials,isIncomeItem, consecutive}})
            
                .then(({data}) => {
                    console.log("====> ","respuesta de movement");
                    console.log("====> ",data);
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron movimientos");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar los movimientos.");
                        return;
                    }
                    newData = data.info;
                })
                .catch(() => toast.error("Error al consultar los movimientos"))
                .finally(() => resolve(newData));
        });
    },
    save(movementList) {
        let code = -1;
        return new Promise(resolve => {
            http.post(movementRoute.SAVE, movementList)
                .then(({data}) => {
                    code = data.code;
                    if (code > 0) {
                        toast.ok("Se registró movimientos correctamente");
                        return;
                    }
                    toast.error(data.message);
                })
                .catch(() => toast.error("Error al guardar al purgar los movimientos"))
                .finally(() => resolve(code));
        });
    },
};